import { useMemo } from 'react';
import { ConditionTarget, ConditionTargetSelect } from '@retail/calculus/components';
import { useFetchAllSuppliers } from '@retail/products/data-access';
import { SupplierBase } from '@retail/suppliers/types';

interface Props {
  value: ConditionTarget | null;
  onChange: (target: ConditionTarget | null) => void;
}

export function ConditionTargetSelectContainer({ value, onChange }: Props) {
  const { data: supplierDtos = [], isLoading } = useFetchAllSuppliers({}, { suspense: false });
  const suppliers = useMemo(() => supplierDtos.map(SupplierBase.fromSupplierDTO), [supplierDtos]);

  return (
    <ConditionTargetSelect
      suppliers={suppliers}
      value={value}
      onChange={onChange}
      isLoading={isLoading}
    />
  );
}
